import Property from './section-components/property';
import Banner from './section-components/banner';
import Homeabout from './section-components/home-about';
import PropertyFilter from './common/PropertyFilter';
import WhyChooseUs from './section-components/why-choose-us';
import Testimonials from './section-components/testimonials';
import CtaSection from './section-components/cta-section';
import SEO from './seo/SEO';

const Home = () => {
    return (
        <div>
            <SEO
                title="Royale Spaces | Open Plots in Amaravati"
                description="Royale Spaces is a trusted real estate company in Amaravati offering APCRDA-approved open plots, residential and commercial properties with verified titles and transparent pricing."
            />
            <Banner />
            <Homeabout />
            <PropertyFilter />
            <Property country={'India'} />
            <WhyChooseUs />
            <Testimonials />
            <CtaSection />
        </div>
    );
};

export default Home;
